
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SurveyLinkStatus {
  export enum SurveyLinkStatus {
    NOT_ASSIGNED = "NOT_ASSIGNED",
    NOT_STARTED = "NOT_STARTED",
    VIEWED = "VIEWED",
    STARTED = "STARTED",
    IN_PROGRESS = "IN_PROGRESS",
    LAST_PAGE = "LAST_PAGE",
    SUBMITTED = "SUBMITTED",
    ASSIGNING = "ASSIGNING",
  }

  export interface SurveyLinkStatusDTO {
    case: string;
  }

  export const fromDTO = (dto: SurveyLinkStatusDTO): SurveyLinkStatus => {
    if (dto === undefined || dto === null) {
      throw new InvalidSurveyLinkStatusError(
        `Invalid DTO ${dto} provided for SurveyLinkStatus.SurveyLinkStatus`
      );
    }
    switch (dto.case) {
      case "NOT_ASSIGNED":
        return SurveyLinkStatus.NOT_ASSIGNED;
      case "NOT_STARTED":
        return SurveyLinkStatus.NOT_STARTED;
      case "VIEWED":
        return SurveyLinkStatus.VIEWED;
      case "STARTED":
        return SurveyLinkStatus.STARTED;
      case "IN_PROGRESS":
        return SurveyLinkStatus.IN_PROGRESS;
      case "LAST_PAGE":
        return SurveyLinkStatus.LAST_PAGE;
      case "SUBMITTED":
        return SurveyLinkStatus.SUBMITTED;
      case "ASSIGNING":
        return SurveyLinkStatus.ASSIGNING;
      default:
        throw new InvalidSurveyLinkStatusError(
          `Case ${dto.case} is not valid case of SurveyLinkStatus.SurveyLinkStatus`
        );
    }
  };

  export const toDTO = (surveyLinkStatus: SurveyLinkStatus): SurveyLinkStatusDTO => {
    const enumDTO = {
      case: SurveyLinkStatus[surveyLinkStatus],
    };
    return enumDTO;
  };
}

export class InvalidSurveyLinkStatusError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusError";
  }
}
export class InvalidSurveyLinkStatusNotAssignedError extends InvalidSurveyLinkStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusNotAssignedError";
  }
}

export class InvalidSurveyLinkStatusNotStartedError extends InvalidSurveyLinkStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusNotStartedError";
  }
}

export class InvalidSurveyLinkStatusViewedError extends InvalidSurveyLinkStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusViewedError";
  }
}

export class InvalidSurveyLinkStatusStartedError extends InvalidSurveyLinkStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusStartedError";
  }
}

export class InvalidSurveyLinkStatusInProgressError extends InvalidSurveyLinkStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusInProgressError";
  }
}

export class InvalidSurveyLinkStatusLastPageError extends InvalidSurveyLinkStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusLastPageError";
  }
}

export class InvalidSurveyLinkStatusSubmittedError extends InvalidSurveyLinkStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusSubmittedError";
  }
}

export class InvalidSurveyLinkStatusAssigningError extends InvalidSurveyLinkStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyLinkStatusAssigningError";
  }
}
